import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ProfileSectionStackProps {
  /** Optional className override; merged via `cn()` over the base styling. */
  className?: string;
  children: ReactNode;
}

/**
 * Vertical-stack wrapper for a tab's primary content rows. Applies the
 * canonical `"flex flex-col gap-6 px-4 pb-8 md:px-8"` styling that frames the
 * default "profile" / "jobs" tab body across every entry point.
 *
 * For the tighter `"px-4 pb-8 md:px-8"` variant (no per-row gap; single
 * self-laid-out child such as the pipeline resume viewer tab), see
 * {@link ProfilePagePadding}.
 */
export function ProfileSectionStack({
  className,
  children,
}: ProfileSectionStackProps) {
  return (
    <div className={cn("flex flex-col gap-6 px-4 pb-8 md:px-8", className)}>
      {children}
    </div>
  );
}
